export default __webpack_public_path__ + "static/ejenta-logo.png?69dafb840120";